import {Component, OnDestroy, OnInit} from '@angular/core';
import {AvailableComponents} from '../../../side-bar/enumAvailableComponents';
import { DataStorageService } from '../../../data-storage.service';
import {ApiService} from '../../../api.service';
import {PricingService} from '../../../pricing.service';
import {MitelHostedModel} from '../../../../models/MitelHosted.model';
import {Internet} from "../../../../models/internet";


@Component({
  selector: 'app-peoplefone-mittel-hosted',
  templateUrl: './peoplefone-mittel-hosted.component.html',
  styleUrls: ['./peoplefone-mittel-hosted.component.scss']
})
export class PeoplefoneMittelHostedComponent implements OnInit, OnDestroy {

  mitelHosted: string[];
  cloundLink: string[];
  teleworked: string[];
  oipCti: string[];
  vpnLink: string[];
  pricingList: MitelHostedModel[];
  constructor(  public dataStorageService: DataStorageService,
                private api: ApiService,
                private pricing: PricingService) {
    this.mitelHosted = [];
    this.cloundLink = [];
    this.teleworked = [];
    this.oipCti = [];
    this.vpnLink = [];
    this.pricingList = [];
    const mitelHosted = new Set();
    this.dataStorageService.mistelHosted_hosted.map(e => {
      mitelHosted.add(e.option);
    });
    this.mitelHosted = Array.from(mitelHosted);

    const cloundLink = new Set();
    this.dataStorageService.mistelHosted_cloundLink.map(e => {
      cloundLink.add(e.option);
    });
    this.cloundLink = Array.from(cloundLink);

    const teleworked = new Set();
    this.dataStorageService.mistelHosted_teleworked.map(e => {
      teleworked.add(e.option);
    });
    this.teleworked = Array.from(teleworked);

    const oipCti = new Set();
    this.dataStorageService.mistelHosted_OipCti.map(e => {
      oipCti.add(e.option);
    });
    this.oipCti = Array.from(oipCti);

    const vpnLink = new Set();
    this.dataStorageService.mistelHosted_VpnLink.map(e => {
      vpnLink.add(e.option);
    });
    this.vpnLink = Array.from(vpnLink);


    this.getValue().then((offer) => {
      this.dataStorageService.currentState.pfMitelHosted.hosted = 'MIVO400VA-Hosted';
      this.dataStorageService.currentState.pfMitelHosted.hosted_monthly =  this.hostedMounthly();
      this.dataStorageService.currentState.pfMitelHosted.hosted_unique = this.hostedUnique();
      this.dataStorageService.currentState.pfMitelHosted.totalMonthlyCost = this.calculateTotalMonthly();
      this.dataStorageService.currentState.pfMitelHosted.totalUniqueCost = this.calculateUnique();
      this.putValue();
    });
  }

  getValue() {
    return this.api.getMitelHosted(this.dataStorageService.currentState.offerID);
  }

  ngOnInit() {
    const element = document.getElementById('pfMittel');
    element.classList.add('active');
    this.dataStorageService.currentComponent = AvailableComponents['PeoplefoneMittel'];

  }

  ngOnDestroy() {
    const element = document.getElementById('pfMittel');
    element.classList.remove('active');
  }


  putValue() {
    return this.api.putMitelHosted(this.dataStorageService.currentState.offerID);
  }

  setValue(event: any, field: string, bandwidth?: string) {
    const data = this.dataStorageService.currentState.pfMitelHosted;
    switch (field) {
      case 'MIVO400-CloudLink':
        data.cloudLink = event.target.value;
        data.checkCloundLink = event.target.checked;
        this.dataStorageService.currentState.pfMitelHosted.cloundLink_monthly = this.CloundLinkMonthly() ;
        this.dataStorageService.currentState.pfMitelHosted.cloundLink_unique = this.CloundLinkUnique();
        break;
      case 'vpnLink':
         data.vpn_link_input = event.target.value;
        this.dataStorageService.currentState.pfMitelHosted.vpn_link = 'VPN Link';
        this.dataStorageService.currentState.pfMitelHosted.vpn_link_monthly =  this.vpnLinkMonthly() * data.vpn_link_input;
        this.dataStorageService.currentState.pfMitelHosted.vpn_link_unique = this.vpnLinkUnique() *  data.vpn_link_input;
        break;
      case 'mbgTeleworker':
        this.dataStorageService.currentState.pfMitelHosted.mbgTeleworker = event.target.value !== '-' ? event.target.value : '';
        this.dataStorageService.currentState.pfMitelHosted.mbgTeleworker_monthly = this.mbgTeleworkerMounthly(event.target.value);
        this.dataStorageService.currentState.pfMitelHosted.mbgTeleworker_unique =  this.mbgTeleworkerUnique(event.target.value) ;
        break;
      case 'oipCTI':
        this.dataStorageService.currentState.pfMitelHosted.oipCTI = event.target.value !== '-' ? event.target.value : '';
        this.dataStorageService.currentState.pfMitelHosted.oipCTI_monthly = this.oipMounthly(event.target.value);
        this.dataStorageService.currentState.pfMitelHosted.oipCTI_unique =  this.oipUnique(event.target.value) ;
        break;
    }

    this.dataStorageService.currentState.pfMitelHosted.totalMonthlyCost = this.calculateTotalMonthly();
    this.dataStorageService.currentState.pfMitelHosted.totalUniqueCost = this.calculateUnique();
    this.putValue();
  }

  CloundLinkMonthly(): number {
    const clound = this.dataStorageService.mistelHosted_cloundLink.filter((e) => {
      return e.option === 'MIVO400-CloudLink';
    });
    let addclound = 0 ;
    if (this.dataStorageService.currentState.pfMitelHosted.checkCloundLink) {
      addclound = clound[0].monthlyCost;
    }
    return addclound;
  }
  CloundLinkUnique(): number {
    const clound = this.dataStorageService.mistelHosted_cloundLink.filter((e) => {
      return e.option === 'MIVO400-CloudLink';
    });
    let addclound = 0 ;
    if (this.dataStorageService.currentState.pfMitelHosted.checkCloundLink) {
      addclound = clound[0].uniqueCost;
    }
    return addclound;
  }


  mbgTeleworkerMounthly(option) {
    const terminal = this.dataStorageService.mistelHosted_teleworked.filter((e) => {
      return e.option === option;
    });
    if (terminal.length === 0) {
      return  0;
    }
    return  terminal[0].monthlyCost;
  }
  mbgTeleworkerUnique(option) {
    const terminal = this.dataStorageService.mistelHosted_teleworked.filter((e) => {
      return e.option === option;
    });
    if (terminal.length === 0) {
      return  0;
    }
    return  terminal[0].uniqueCost;
  }

  oipMounthly (option) {
    const oip = this.dataStorageService.mistelHosted_OipCti.filter((e) => {
      return e.option === option;
    });
    if (oip.length === 0) {
      return  0;
    }
    return  oip[0].monthlyCost;
  }
  oipUnique(option) {
    const oip = this.dataStorageService.mistelHosted_OipCti.filter((e) => {
      return e.option === option;
    });
    if (oip.length === 0) {
      return  0;
    }
    return  oip[0].uniqueCost;
  }

  hostedMounthly() {
    const hosted = this.dataStorageService.mistelHosted_hosted.filter((e) => {
      return true;
    });
    return  hosted[0].monthlyCost;
  }
  hostedUnique() {
    const hosted = this.dataStorageService.mistelHosted_hosted.filter((e) => {
      return true;
    });
    return  hosted[0].uniqueCost;
  }

  vpnLinkMonthly(): number {
    const vpn = this.dataStorageService.mistelHosted_VpnLink.filter((e) => {
      return e.option === 'Additional VPN';
    });
    return  vpn[0].monthlyCost;
  }

  vpnLinkUnique(): number {
    const vpn = this.dataStorageService.mistelHosted_VpnLink.filter((e) => {
      return e.option === 'Additional VPN';
    });
     return vpn[0].uniqueCost;
  }

  calculateTotalMonthly(): number {
    return this.hostedMounthly() + this.CloundLinkMonthly() +
      this.dataStorageService.currentState.pfMitelHosted.vpn_link_monthly +
      this.dataStorageService.currentState.pfMitelHosted.mbgTeleworker_monthly +
      this.dataStorageService.currentState.pfMitelHosted.oipCTI_monthly;
  }

  calculateUnique(): number {
    return this.hostedUnique() + this.CloundLinkUnique() +
      this.dataStorageService.currentState.pfMitelHosted.vpn_link_unique +
      this.dataStorageService.currentState.pfMitelHosted.mbgTeleworker_unique +
      this.dataStorageService.currentState.pfMitelHosted.oipCTI_unique;
  }

}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/peoplefone-mittel-hosted/peoplefone-mittel-hosted.component.ts